import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  customGroupWrapperStyles: {
    backgroundColor: '#F5F5F5',
  },
  iteratorWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
  },
  iteratorFooter: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
}));
